<div id="quill-editor-note">
</div>
<div id="quill-editor-note-info" style="display: none;">
    <span class="font-500 font-12 mb-2 d-block">
        How to tag a user on a note?
    </span>
    <p class="mb-0 font-10">
        Type '@' and enter the first three characters of a name of the user, then the list of users respective to the
        linked with the job and property matching to the characters entered will be suggested with a list.
    </p>
    <p class="mb-0 font-10">
        Choose the person, you want to mention on the note from the list of suggestions.
    </p>
</div>